






































import Vue from 'vue'
// @ts-ignore
import VcPiechart from 'vc-piechart'
import 'vc-piechart/dist/lib/vc-piechart.min.css'
import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue';
import helpPopover from '@/components/Ui/HelpPopover/HelpPopover.vue'
import Mailing from '@/models/mailing/mailing'
import {MAILING_STATUS_PROGRESS} from '@/constants';

export default Vue.extend({
  props: {
    scope: {} as () => {mailing: Mailing},
    options: {}
  },
  components: {
    infoRowsBlock,
    helpPopover,
    VcPiechart
  },
  computed: {
    sentOk (): number {
      return this.scope.mailing.getSentOk();
    },
    sentErr (): number {
      return this.scope.mailing.getSentErr();
    },
    rcptNum (): number {
      return this.scope.mailing.getRcptNum()
    },
    inTurn (): number {
      return this.rcptNum - (this.sentOk + this.sentErr)
    },
    msgsNum (): number {
      return this.scope.mailing.getMsgsNum()
    },
    sections (): Array<{value: number, color: string}> {
      let ok = {
        value: Math.ceil(Number(((this.sentOk / this.rcptNum) * 100).toFixed(3))),
        color: '#2AC360'
      }
      let err = {
        value: Math.ceil(Number(((this.sentErr / this.rcptNum) * 100).toFixed(3))),
        color: '#C8C8C8'
      }
      let inTurn = {
        value: Math.ceil(Number(((this.inTurn / this.rcptNum) * 100).toFixed(3))),
        color: '#eeeeee'
      }
      let sections = []
      if (ok.value > 0) sections.push(ok)
      if (err.value > 0) sections.push(err)
      if (inTurn.value > 0) sections.push(inTurn)
      return sections;
    },
    isProgress (): boolean {
      return this.scope.mailing.getStatus() === MAILING_STATUS_PROGRESS
    }
  }
})
